export const forbiddenError = 403
export const unauthorizedErrors = [401, 440]
